/**
 * SS-DEMO-003: Demo Badge Component
 *
 * Displays a prominent badge when the active facility is a demo facility.
 * Styled to be visually distinct from production data.
 */

import React from 'react';

interface DemoBadgeProps {
  isDemo: boolean;
  className?: string;
}

export const DemoBadge: React.FC<DemoBadgeProps> = ({ isDemo, className = '' }) => {
  if (!isDemo) return null;

  return (
    <div
      className={`inline-flex items-center gap-2 px-3 py-1.5 bg-yellow-100 border-2 border-yellow-400 rounded-md ${className}`}
      role="status"
      aria-label="Demo Mode"
    >
      <svg
        className="w-4 h-4 text-yellow-600"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={2}
          d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
      <span className="text-sm font-semibold text-yellow-800 uppercase tracking-wide">
        Demo Mode
      </span>
    </div>
  );
};

export default DemoBadge;
